import React from 'react';
import NmsLkMeetingPage from '../../../../pages/NmsLkMeetingPage';
import NmsMeetingInfoPage from '../../../../pages/NmsMeetingInfoPage';
import NmsProfilePage from '../../../../pages/NmsProfilePage';
import { RoutePathsType } from '../../../../types';
import { routerPath } from '../../../routerPath';

export const nmsRoutes: RoutePathsType = [
  {
    path: routerPath.nmsProfile,
    name: 'Личный кабинет',
    Component: <NmsProfilePage />,
  },
  {
    path: routerPath.nmsProfileMeeting,
    name: 'Заседания НМС',
    Component: <NmsLkMeetingPage />,
  },
  {
    path: routerPath.nmsInfoMeetingId,
    name: 'Заседание НМС',
    Component: <NmsMeetingInfoPage />,
  },
];
